import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AuditService, ActivityTypes } from '../../../../services/audit.service';
// import { itemAt } from '@progress/kendo-angular-grid/dist/es/data/data.iterators';
import * as moment from 'moment';

@Component({
  selector: 'app-research-portal-stats-daily-access-data',
  templateUrl: './research-portal-stats-daily-access-data.component.html',
  styleUrls: ['./research-portal-stats-daily-access-data.component.scss'],
})
export class ResearchPortalStatsDailyAccessDataComponent implements OnInit {
  @Output() seriesClicked: EventEmitter<any> = new EventEmitter();
  dailyAccessData: any;

  // Filters
  fromDate = moment(Date.now()).startOf('week').format('YYYY-MM-DD');
  toDate = moment(Date.now()).format('YYYY-MM-DD');

  constructor(private auditService: AuditService) {}

  ngOnInit() {
    this.getDailyAccessData();
  }

  async getDailyAccessData() {
    let dailyAccessData = await this.auditService.getDailyAccessData(this.fromDate, this.toDate);
    // dailyAccessData

    this.dailyAccessData = dailyAccessData.map((item) => {
      let activity = ActivityTypes.find((e) => e.type === item.type);
      if (activity) {
        item.typeName = activity.name;
      }
      return item;
    });
  }

  onSeriesClick(e) {
    this.seriesClicked.emit(e.series.name);
  }
}
